module.exports = __webpack_public_path__ + "fonts/not-allowed.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-grid/src/styles/icons/not-allowed.svg
// module id = 1327
// module chunks = 2